<app-success-overlay
  *ngIf="isRedirect"
  [status]="overlayStatus"
  [loadingTitle]="'checkout.cart.overlay.redirection.title' | translate"
  [loadingDescription]="
    'checkout.cart.overlay.redirection.description' | translate
  "
>
</app-success-overlay>

<button
  app-vtmn-play-icon-button
  type="button"
  class="cart-button"
  [type]="ctaButtonType.Button"
  [size]="vtmnPlayButtonSize.LARGE"
  [variant]="vtmnPlayIconButtonVariant.TERTIARY"
  (click)="openCartContent()"
  data-test="cart-entry"
  aria-label="Open cart"
>
  <vtmn-play-icon class="cart-button__icon" [name]="cartIcon"></vtmn-play-icon>
  <span
    *ngIf="!isCartEmpty && !isLoading"
    class="cart-button__items"
    [class.cart-button__items--two-digits]="lowerSize"
  >
    {{ getCartItemsNumber() }}
  </span>
</button>

<app-panel
  [isCart]="true"
  [panelTitle]="cartTitle"
  [isOpen]="isCartOpen"
  (panelClose)="closeCartContent()"
  class="cart-panel"
>
  <ng-container panel-header-content #headerContent>
    <span class="cart-panel__subtitle">{{ totalItemsInCart }}</span>
  </ng-container>

  <ng-container panel-content>
    <div class="spinner mx-auto my-8" *ngIf="isLoading"></div>
    <section *ngIf="isCartEmpty && !isLoading" class="cart-panel__empty">
      <img
        class="cart-panel__empty__image"
        src="assets/cart/cart-empty.svg"
        [alt]="'activity.loyalty.image' | translate"
      />
      <p>
        {{ 'checkout.cart.empty' | translate }}
      </p>
    </section>
    <app-checkout-summary
      *ngIf="!isCartEmpty"
      (closeCart)="closeCartContent()"
      (noTimeslotAvailability)="disableCartSubmission($event)"
      [items]="cartItems"
      [isImageDisplayed]="false"
      [showExternalPayment]="showExternalPayment"
      [isCart]="true"
      [isVatDisplayed]="true"
    ></app-checkout-summary>
  </ng-container>
  <ng-container panel-footer #footerContent>
    <ng-container *ngIf="!isCartEmpty">
      <section class="cart-panel__summary-total">
        <p class="cart-panel__summary-total__amount">
          <span>{{ 'checkout.cart.total' | translate }}</span>
          <span>{{ totalPrice }}</span>
        </p>
        <em
          *ngIf="taxes && isTaxesDisplayed"
          class="cart-panel__summary-total__taxes"
        >
          {{ 'checkout.summary.table.column.duty_free' | translate }}
        </em>
      </section>
      <ng-container
        *ngIf="
          (isFreeCheckout && !bmsTerms) ||
          (isFreeCheckout && bmsTerms?.length > 0 && isBmsConsentMandatory)
        "
      >
        <app-form-checkbox
          class="cart-panel__terms"
          [align]="checkboxAlign"
          [label]="legalTermsText"
          (change)="consent = !consent"
        ></app-form-checkbox>
      </ng-container>
      <ng-container
        *ngIf="isFreeCheckout && bmsTerms?.length > 0 && !isBmsConsentMandatory"
      >
        <p
          class="cart-panel__conditions"
          [innerHTML]="legalTermsText | safeHtml"
        ></p>
      </ng-container>
      <ng-container *ngIf="isFreeCheckout && !isBms">
        <app-form-checkbox
          class="cart-panel__terms"
          [align]="checkboxAlign"
          [label]="'checkout.summary.imageRightsConsent' | translate"
          (change)="imageRightsConsent = !imageRightsConsent"
        ></app-form-checkbox>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="!isCartEmpty">
      <button
        *ngIf="!isCartEmpty && !cartIsFull"
        app-vtmn-play-button
        type="button"
        class="w-full mb-3"
        [type]="ctaButtonType.Button"
        [variant]="vtmnPlayButtonVariant.SECONDARY"
        [shape]="vtmnPlayButtonShape.SQUARED"
        (click)="goToActivity()"
      >
        {{ 'checkout.cart.add_timeslot' | translate }}
      </button>
      <button
        *ngIf="!isCartEmpty"
        app-vtmn-play-button
        type="button"
        class="w-full"
        [type]="ctaButtonType.Button"
        [disabled]="
          (isFreeCheckout && !consent) || noCartSubmission || hasClicked
            ? true
            : null
        "
        [attr.data-disabled]="
          (isFreeCheckout && !consent) || noCartSubmission || hasClicked
            ? true
            : null
        "
        [shape]="vtmnPlayButtonShape.SQUARED"
        (click)="checkUserConnexion()"
        data-test="continue-subscription"
      >
        {{ cartButtonTranslation }}
      </button>
    </ng-container>
    <ng-container *ngIf="!isCartEmpty">
      <button
        *ngIf="isCartEmpty"
        app-vtmn-play-button
        type="button"
        class="w-full"
        [type]="ctaButtonType.Button"
        [shape]="vtmnPlayButtonShape.SQUARED"
        (click)="closeCartContent()"
      >
        {{ 'checkout.cart.close' | translate }}
      </button>
    </ng-container>
  </ng-container>
</app-panel>
